const cn = {
	language: {
		language: 'EN'
	},
	nav: {
		text1: '请输入搜索关键词',
		text2: '产品分类',
		text3: '应用场景',
		text4: '请输入您想搜索的内容',
		text5: '产品中心',
		text6: '首页',
	},
	footer: {
		text1: '总部地址：',
		text2: '生产地址：北京市房山区窦大路九区30号',
		text3: '注册地址：北京市昌平区生命园路29号C座100号',
		text4: '关联网站',
		text5: 'Copyright 库尔科技 All rights reserved.',
		text6: '首页',
		text7: '产品中心',
	},
	index: {},
	product: {
		text0: '产品中心',
		text1: '库尔 · 产品中心',
		text2: '为全球提供 实惠 易用 精准 的诊断产品',
		text3: '全部产品',
		text4: '首页',
		text5: '产品中心',
		text6: '查看',
		text7: '展开筛选',
		text8: '重置筛选',
		text9: '请输入搜索关键词',
		text10: '搜索',
		text11: '筛选条件',
		text12: '应用场景',
		text13: '产品分类',
		text14: '清除条件',
		text15: '确定',
		text16: '全选',
		text17: '产品名称',
		text18: '在线咨询',
		text19: '产品参数',
		text20: '数据请求异常',
	},
	about: {},
	news: {
		text0: '新闻资讯',
		text1: '首页',
		text2: '常识推荐',
		text3: '上一篇：',
		text4: '下一篇：',
		text5: '数据请求异常',
	},
	support: {
		text0: '技术支持',
		text1: '库尔 · 技术支持',
		text2: '大自然科学原理 丨 已经证实&当前无法验明真伪的存在',
		text3: '首页',
		text4: '常识推荐',
		text5: '上一篇：',
		text6: '下一篇：',
		text7: '数据请求异常',
	}
};

export default cn